// PopUpCamara.tsx
import React from 'react';

interface PopUpProps {
    description: string;
    id: string;
    imageUrl?: string;
}

const PopUpCamara: React.FC<PopUpProps> = (props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <strong>Cámara {props.id}</strong>
            <p style={{ textAlign: "center", marginTop: '1px', marginBottom: '1px' }}>{props.description}</p>
            {props.imageUrl && (
                <img src={props.imageUrl} alt={`Camera ${props.id}`} width="200" height="150" />
            )}
        </div>
    );
};

export default PopUpCamara;
